import {Module} from '@mamdev/cad.static-next-lib';

/**
 * The image caption module
 */
export default class ImageCaption extends Module {
  private collapsed: boolean;
  private image: HTMLElement | null;
  private openStateClass: string;

  static attachTo(root: HTMLElement): ImageCaption {
    return new ImageCaption(root);
  }

  constructor(root: HTMLElement) {
    super(root);
    this.name_ = 'imagecaption';
    this.collapsed = true;
    this.image = null;
  }

  /**
   * Start the module
   */
  start() {
    this.openStateClass = 'open-subtext';
    this.image = this.root_.parentElement;
    this.setupEventListeners();
  }

  /**
   * Create click functionality
   */
  setupEventListeners() {
    if (this.image === null) {
      return;
    }
    this.root_.addEventListener('click', () => {
      if (!this.collapsed) {
        this.image?.classList.remove(this.openStateClass);
        this.collapsed = true;
        this.publish('figcaption:setPixel', {
          click1: 'undefined',
          click2: 'undefined',
          click3: 'undefined',
          click4: 'undefined',
          referrer: 'undefined',
          clickname: 'caption_close'
        });
        this.publish('imagecaption:close', {});
      }
    });

    const copyright = this.image.getElementsByClassName('expand-copyright')[0];

    if (copyright) {
      copyright.addEventListener('click', e => {
        if (this.collapsed) {
          this.image?.classList.add(this.openStateClass);
          this.collapsed = false;

          e.stopPropagation();
          this.publish('figcaption:setPixel', {
            click1: 'undefined',
            click2: 'undefined',
            click3: 'undefined',
            click4: 'undefined',
            referrer: 'undefined',
            clickname: 'caption_open'
          });
          this.publish('imagecaption:open', {});
        }
      });
    }
  }
}
